import { Navigate, Outlet } from 'react-router-dom';
import { useHybridAuth } from './HybridAuthContext';

const FGAdminGuard = () => {
    const { user, authType } = useHybridAuth();

    const allowed =
        authType === 'sso' &&
        user?.admin === true &&
        typeof user?.email === 'string' &&
        user.email.toLowerCase().endsWith('@fetchgoat.com');

    if (!allowed) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default FGAdminGuard;
